const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Workshop Instance Host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('workshopInstanceZoomHost', ['Application', 'Authorization', 'WorkshopInstances', 'UserWorkshops', 'Workshops', 'Categories', 'ZoomIntegrate', '$translate', function (Application, Authorization, WorkshopInstances, UserWorkshops, Workshops, Categories, ZoomIntegrate, $translate) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../templates/directives/ws-instance-zoom-manager.html'),
    controller: ['$scope', function ($scope) {
      const self = this;
      const routeParameters = Application.navigation.getRouteParameters();
      const instanceId = routeParameters.id;

      if (!instanceId) {
        Application.messaging.addMessage({status: 'error', duration: 5, text: 'No id in route params'});
        return;
      }

      self.activeUUID = function(uuid) {
        return uuid && uuid === self.zoomData.active_post_uuid;
      };

      self.setActiveUUID = async function(uuid) {
        try {
          await WorkshopInstances.updatePostUUID({group: instanceId}, {uuid}).$promise;
          Application.messaging.addMessage({status: 'success', duration: 5, text: 'Post uuid updated'});
          self.initialize();
        } catch (error) {
          Application.messaging.addMessage({status: 'error', duration: 5, text: 'Error in updating post uuid'});
        }
      }

      self.initialize = async function() {
        self.instance = await WorkshopInstances.get({subresource: instanceId}).$promise
        if (!self.instance.zoom_meeting_id) {
          Application.messaging.addMessage({status: 'error', duration: 5, text: 'Not a valid zoom instance'});
          return;
        }

        self.zoomData = await WorkshopInstances.getZoomHistory({group: instanceId}).$promise;
        $scope.$apply();
      };

      self.initialize();

    }],
    controllerAs: 'zoomHost'
  }
}]);